<template>
<Wrapper
    v-show="
      component &&
      !preview && renderTools &&
      ![
        'reheight_widget',
        'remargin_widget',
        'crop_image',
        'sort_widget',
      ].includes(mode) &&
      parentWidgetActive.id
    "
    :position="parentWidgetActive.position"
    :parentWidget="true"
    id="parent-widget-active"
>
    <WidgetHover :class="getParentClass()" >
      {{ widgetTypeShow }}
    </WidgetHover>
</Wrapper>
  
</template>

<script>
import { mapGetters } from "vuex";
import { Wrapper} from "./WidgetActive.styled";
import { WidgetHover } from "./WidgetHover.styled";

import { WIDGET } from "@model/components/componentMeta.model";

export default {
    components:{
        Wrapper,
        WidgetHover
    },
    computed:{
        ...mapGetters({
            parentWidgetActive: "designIframe/frame/parentWidgetActive",
            component: "designIframe/component/component",
            widgetActive: "designIframe/frame/widgetActive",
            components: "designIframe/metadata/components",
            preview: "designIframe/preview",
            mode: "designIframe/mode",
            renderTools: "designIframe/frame/renderTools",
        }),
        component() {
            return this.components[this.parentWidgetActive.id];
        },
        widgetType() {
            return this.component && this.component.type;
        },
        widgetTypeShow() {
        if(!this.widgetType) return "";
        let type = "";
        switch (this.widgetType) {
            case "SECTION_WIDGET_LINE_SEPARATE":
            type = "line";
            break;
            case "HEADER_WIDGET_MENU":
            type = "Header Menu";
            break;
            case "HEADER_WIDGET_LOGO":
            type = "Logo";
            break;
            case "HEADER_WIDGET_MEMBER":
            type = "Member";
            break;
            case "HEADER_WIDGET_SOCIAL":
            type = "Social";
            break;
            case "HEADER_WIDGET_LANGUAGE":
            type = "Language";
            break;
            case "HEADER_WIDGET_CURRENCY":
            type = "Currency";
            break;
            case "HEADER_WIDGET_SEARCH":
            type = "Search";
            break;
            case "HEADER_WIDGET_TEXT":
            type = "Text";
            break;
            case "HEADER_WIDGET_TOPMENU":
            type = "Top Menu";
            break;
            case "HEADER_WIDGET_CART":
            type = "Cart";
            break;
            case "FOOTER_WIDGET_MENU":
            type = "Footer Menu";
            break;
            case "FOOTER_WIDGET_LOGO":
            type = "Logo";
            break;
            case "FOOTER_WIDGET_SUBSCRIBE":
            type = "Subscribe";
            break;
            case "FOOTER_WIDGET_SOCIAL":
            type = "Social";
            break;
            case "FOOTER_WIDGET_PARTNER":
            type = "Partner";
            break;
            case "FOOTER_WIDGET_COPYRIGHT":
            type = "Copyright";
            break;
            case "FOOTER_WIDGET_STATCOUNTER":
            type = "Stat Counter";
            break;
            case "FOOTER_WIDGET_TEXT1":
            type = "Text";
            break;
            case "FOOTER_WIDGET_TEXT2":
            type = "Text";
            break;
            case "FOOTER_WIDGET_TEXT3":
            type = "Text";
            break;
            case "FOOTER_WIDGET_TEXT4":
            type = "Text";
            break;
            default:
            type = this.widgetType.replace(WIDGET.prefixType, "")
            break;
        }
        return this.$helper.text.capitalize(type);
    },
    },
    methods : {
        getParentClass(){
            let classParent = 'label-name-frame '
            if(
                this.component && 
                (
                    this.component.componentsID.includes(this.widgetActive.id) || 
                    this.component.componentsIDHover.includes(this.widgetActive.id)
                )
            )
            {
                return classParent + 'parent-active'
            }
            else if(this.parentWidgetActive.id){
                return classParent + 'active'
            }else{
                return classParent + 'disabled'
            }
        }
    }
}
</script>


<style>

</style>